// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + "2ac4b2a86608f7b4138d" + ".bundle.js";
};